import { Props_SnippetJobLinks } from "./JobLinks.props";
import SharedHeading from "../Shared/Heading/Heading";
import SharedLink from "../Shared/Link/Link";

const SnippetJobLinks = (props: Props_SnippetJobLinks) => {
    const { heading, links, repeatable_links } = props;

    const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';

    const linkAlignmentClass = links.alignment?.value
        ? `snippet-job-links__link-container--${links.alignment.value}`
        : "";

    return (
        <section className={`snippet-job-links`}>
            <div className="snippet-job-links__container">
                <SharedHeading
                    className="snippet-job-links__heading"
                    alignment={
                        ["start", "center", "end"].includes(
                            heading.alignment?.value as string
                        )
                            ? (heading.alignment?.value as
                                  | "start"
                                  | "center"
                                  | "end")
                            : undefined
                    }
                    level={headingLevel}
                    visibility={typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'}
                >
                    {heading.text?.value}
                </SharedHeading>
                <div
                    className={`snippet-job-links__link-container ${linkAlignmentClass}`}
                >
                    {repeatable_links.map((item, idx) => (
                        <div className="snippet-job-links__item" key={idx}>
                            {item.image?.value && (
                               <figure className="snippet-job-links__item-image-container">
                                   <img
                                       className="snippet-job-links__item-image"
                                       src={item.image.value}
                                       alt={item.imageAlt?.value || ""}
                                       loading="lazy"
                                       height="180"
                                       width="425"
                                   />
                               </figure>
                            )}
                            <SharedLink
                                url={item.linkHref?.value}
                                linkStyles={item.linkStyle?.value}
                                openInNewTab={!!item.linkTarget?.value}
                                className="snippet-job-links__item-link"
                            >
                                {item.linkText?.value}
                            </SharedLink>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SnippetJobLinks;
